/*********** Reduceres defined here *********/

import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/es/storage"; // default: localStorage if web, AsyncStorage if react-native
import { routerReducer } from "../config/historySetup";

// reducers
import user from "./modules/user";
import loader from "./modules/loader";
import search from "./modules/search";
import WebsiteDetails from "./modules/WebsiteDetailReducer";

const userPersistConfig = {
  key: "admin-app",
  storage: storage,
  blacklist: ["router", "loader"],
};

export default persistCombineReducers(userPersistConfig, {
  router: routerReducer,
  loader,
  user,
  search,
  WebsiteDetails,
});
